import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import React from "react";

const ConfirmStatusChangeModal = ({
  isOpen,
  onClose,
  statusFlag,
  handleConfirmChangeStatus,
  loading,
}) => {
  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => {
          onClose();
        }}
        className="relative z-50"
      >
        <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity" />

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel className="relative w-full transform overflow-hidden bg-white text-left shadow-xl transition-all rounded-lg sm:max-w-md md:max-w-lg">
              <div className="bg-[#21140E0F] px-4 pb-6 pt-3 sm:px-6">
                <div className="flex justify-between items-center">
                  <DialogTitle className="text-lg sm:text-xl font-bold text-[#284184]">
                    {statusFlag.status === "Approve" ? "Approve" : "Reject"}{" "}
                    Confirmation
                  </DialogTitle>
                  <button
                    onClick={() => {
                      onClose();
                    }}
                    className="text-[#1C2024] hover:bg-gray-100 p-1.5 rounded-full transition-colors"
                  >
                    <span className="text-2xl sm:text-4xl leading-none">
                      &times;
                    </span>
                  </button>
                </div>
                <div>
                  <p>Are you sure you want to this request?</p>
                  <div className="mt-5 text-right">
                    <button
                      className="text-white bg-[#F04438] rounded-xl border px-4 pt-1 pb-2"
                      onClick={() => onClose()}
                    >
                      Cancel
                    </button>
                    <button
                      className="text-white bg-[#284184] rounded-xl border ml-4 px-4 pt-1 pb-2"
                      onClick={() => handleConfirmChangeStatus()}
                    >
                      {loading
                        ? "Loading..."
                        : statusFlag.status === "Approve"
                        ? "Approve"
                        : "Reject"}
                    </button>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default ConfirmStatusChangeModal;
